export default "__VITE_ASSET__yrra3zlt__"